export default __webpack_public_path__ + "static/media/05.0a954f5b.jpg";